export default __webpack_public_path__ + "static/media/Twisted Yarns.6bbfb73b.jpg";